import { defineNuxtRouteMiddleware, navigateTo, useRequestHeaders, useRuntimeConfig } from "#app";
import { deviceType } from "~/utils/deviceType";
import qs from "qs"
export default defineNuxtRouteMiddleware((to) => {
  const runtimeConfig = useRuntimeConfig();
  if (!runtimeConfig.public.isCmsSite) {
    return;
  }

  const userAgent = process.server
    ? (useRequestHeaders(["user-agent"])["user-agent"] || "")
    : navigator.userAgent;
  const currentDevice = deviceType(userAgent || "");
  const isPc = currentDevice?.type === "pc";

  if ((to.path === "/" || to.path === "") && !isPc) {
    if(!process.server){
      
      return window.location.href="/h5/"+ window.location.search;
    }
    return navigateTo({ path: "/h5/", query: to.query }, { redirectCode: 302, replace: true });
  }

  if (to.path.includes("/apph5") && !isPc) {
    if(!process.server){
      return window.location.href="/apph5/"+ window.location.search;
    }
    return navigateTo({ path: "/apph5/", query: to.query }, { redirectCode: 302, replace: true });
  }

  if ((to.path === "/lch5" || to.path === "/lch5/") && !isPc) {
    if(!process.server){
      return window.location.href="/lch5/"+ window.location.search;
    }
    return navigateTo({ path: "/lch5/", query: to.query }, { redirectCode: 302, replace: true });
  }

  if (to.path.includes("/detail/pc") && !isPc) {
    if(!process.server){
      return window.location.href="/detail/"+ window.location.search;
    }
    return navigateTo({ path: "/detail", query: to.query }, { redirectCode: 302, replace: true });
  }
});
